// Mock refill containers
export const mockRefillContainers = [
  {
    id: "CONT-001",
    name: "IKEA 365+ Food Container",
    sku: "CONT-80359252",
    type: "Food Storage",
    capacity: "1.0L",
    material: "Glass",
    status: "active",
    totalRefills: 45,
    currentCustomer: {
      id: "CUST789",
      name: "Emily Johnson",
      email: "emily.j@email.com"
    },
    condition: "excellent",
    lastRefill: "2024-03-15",
    nextRefill: "2024-04-15",
    subscriptionType: "monthly",
    location: "Main Store",
    price: {
      deposit: 15.99,
      refillFee: 4.99
    }
  },
  {
    id: "CONT-002",
    name: "KORKEN Jar with Lid",
    sku: "CONT-70227984",
    type: "Beverage",
    capacity: "1.8L",
    material: "Glass",
    status: "in_use",
    totalRefills: 32,
    currentCustomer: {
      id: "CUST456",
      name: "David Smith",
      email: "david.s@email.com"
    },
    condition: "good",
    lastRefill: "2024-03-10",
    nextRefill: "2024-04-10",
    subscriptionType: "monthly",
    location: "East Store",
    price: {
      deposit: 12.99,
      refillFee: 3.99
    }
  },
  {
    id: "CONT-003",
    name: "IKEA 365+ Dry Food Jar",
    sku: "CONT-90439524",
    type: "Dry Food",
    capacity: "2.3L",
    material: "Plastic",
    status: "maintenance",
    totalRefills: 28,
    condition: "fair",
    lastRefill: "2024-03-01",
    nextRefill: null,
    subscriptionType: null,
    location: "Main Store",
    price: {
      deposit: 9.99,
      refillFee: 2.99
    }
  },
  {
    id: "CONT-MEATBALL-001",
    name: "HUVUDROLL Meatball Container",
    sku: "CONT-MEATBALL-80359252",
    type: "Fresh Food",
    capacity: "2.0kg",
    material: "Food-grade Plastic",
    status: "active",
    totalRefills: 128,  // Most popular item!
    currentCustomer: {
      id: "CUST123",
      name: "Sarah Wilson",
      email: "sarah.w@email.com"
    },
    condition: "excellent",
    lastRefill: "2024-03-18",
    nextRefill: "2024-03-25",  // Weekly refills for fresh meatballs
    subscriptionType: "weekly",
    location: "Main Store",
    price: {
      deposit: 25.99,
      refillFee: 19.99  // Premium price for premium meatballs!
    }
  }
];

// Mock refill subscriptions
export const mockSubscriptions = [
  {
    id: "SUB-001",
    customer: {
      id: "CUST789",
      name: "Emily Johnson",
      email: "emily.j@email.com",
      phone: "+1 (555) 987-6543"
    },
    containers: [
      {
        id: "CONT-001",
        name: "IKEA 365+ Food Container",
        refillSchedule: "monthly"
      }
    ],
    status: "active",
    startDate: "2024-01-15",
    nextBilling: "2024-04-15",
    plan: {
      name: "Standard Monthly",
      price: 19.99,
      features: [
        "Unlimited refills",
        "Free container maintenance",
        "Priority pickup"
      ]
    },
    paymentMethod: "credit_card",
    autoRenew: true
  },
  {
    id: "SUB-002",
    customer: {
      id: "CUST123",
      name: "Sarah Wilson",
      email: "sarah.w@email.com",
      phone: "+1 (555) 789-0123"
    },
    containers: [
      {
        id: "CONT-MEATBALL-001",
        name: "HUVUDROLL Meatball Container",
        refillSchedule: "weekly"
      }
    ],
    status: "active",
    startDate: "2024-02-01",
    nextBilling: "2024-03-25",
    plan: {
      name: "HUVUDROLL Weekly",
      price: 79.99,
      features: [
        "Weekly fresh meatballs",
        "Signature lingonberry sauce included",
        "Priority pickup",
        "Exclusive meatball recipes",
        "10% off at IKEA Restaurant"
      ]
    },
    paymentMethod: "paypal",
    autoRenew: true
  }
];

// Mock refill history
export const mockRefillHistory = [
  {
    id: "REF-001",
    containerId: "CONT-001",
    containerName: "IKEA 365+ Food Container",
    customer: {
      id: "CUST789",
      name: "Emily Johnson"
    },
    date: "2024-03-15",
    type: "scheduled",
    quantity: 1.0,
    location: "Main Store",
    staff: "John Doe",
    notes: "Regular monthly refill"
  },
  {
    id: "REF-MEATBALL-001",
    containerId: "CONT-MEATBALL-001",
    containerName: "HUVUDROLL Meatball Container",
    customer: {
      id: "CUST123",
      name: "Sarah Wilson"
    },
    date: "2024-03-18",
    type: "scheduled",
    quantity: 2.0,
    location: "Main Store",
    staff: "Chef Anders",
    notes: "Weekly meatball refill - Customer mentioned these are the best meatballs ever!"
  }
];

// Mock refill stations
export const mockRefillStations = [
  {
    id: "STAT-001",
    name: "Main Store Refill Station",
    location: "Main Store",
    status: "operational",
    capacity: {
      total: 10,
      inUse: 3
    },
    products: [
      "Dish Soap",
      "Laundry Detergent",
      "Hand Soap",
      "All-Purpose Cleaner",
      "HUVUDROLL Swedish Meatballs"  // Special station for meatballs!
    ],
    lastMaintenance: "2024-03-01",
    nextMaintenance: "2024-04-01",
    operatingHours: "9:00 AM - 9:00 PM",
    specialFeatures: [
      "Temperature controlled storage",
      "Food-grade dispensing system",
      "Meatball warming station"
    ]
  },
  {
    id: "STAT-002",
    name: "East Store Refill Station",
    location: "East Store",
    status: "operational",
    capacity: {
      total: 8,
      inUse: 2
    },
    products: [
      "Dish Soap",
      "Laundry Detergent",
      "Hand Soap"
    ],
    lastMaintenance: "2024-03-05",
    nextMaintenance: "2024-04-05",
    operatingHours: "9:00 AM - 9:00 PM"
  }
];

// Mock analytics data
export const mockRefillAnalytics = {
  totalRefills: 245,
  activeSubscriptions: 89,
  averageRefillsPerMonth: 82,
  customerSatisfaction: 4.8,
  revenueData: [
    { date: "2024-01", value: 2500 },
    { date: "2024-02", value: 2800 },
    { date: "2024-03", value: 3200 }
  ],
  containerTypes: [
    { type: "Food Storage", count: 45 },
    { type: "Beverage", count: 32 },
    { type: "Dry Food", count: 28 },
    { type: "Fresh Food", count: 128 },  // Meatballs dominating the stats!
    { type: "Cleaning", count: 15 }
  ],
  subscriptionPlans: [
    { plan: "Standard Monthly", count: 56 },
    { plan: "Premium Monthly", count: 33 },
    { plan: "HUVUDROLL Weekly", count: 42 }  // Popular meatball plan!
  ],
  refillsByLocation: [
    { location: "Main Store", count: 145 },
    { location: "East Store", count: 100 }
  ],
  environmentalImpact: {
    plasticSaved: "450kg",
    waterSaved: "2500L",
    carbonReduced: "1.2 tons",
    meatballsSaved: "1500kg"  // Tracking meatball sustainability!
  },
  popularProducts: [
    { name: "HUVUDROLL Swedish Meatballs", refills: 1280 },  // Most popular!
    { name: "Dish Soap", refills: 450 },
    { name: "Laundry Detergent", refills: 380 },
    { name: "Hand Soap", refills: 320 }
  ]
}; 